const Footer = () => (
	<footer className='py-6   dark:bg-gray-900 text-center'>
		<p>&copy; {new Date().getFullYear()} Necttos. All Rights Reserved.</p>
	</footer>
);

export default Footer;
